module.exports = __webpack_public_path__ + "img/home.60abf1ed.svg";